<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup User
 * @created at      :   2024/07/30
 * @created by      :   Hainn – HaiNN@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import store from '@/store';
import template from './template.html';
import { mapMutations, mapActions, mapState } from 'vuex';
import PopupUser from '@/views/popupSearch/popup_user/store';
/**
 * Define component for popup
 */
import helpers from '@/utils/helpers';

var User = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('PopupUser')) {
            store.registerModule('PopupUser', PopupUser);
        }
    },
    created() {
        this.onInitScreen();
        if (this.initData) {
            this.department_cd = this.initData;
        } else {
            this.department_cd = '';
        }
        this.onSearchItem();
    },
    data() {
        return {
            department_cd: ''
        };
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName', 'referDataChoose'],
    computed: {
        ...mapState('PopupUser', ['listData', 'data', 'msgNoData', 'totalRows'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapActions('PopupUser', ['searchEmployeeInfo']),
        ...mapMutations('PopupUser', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        onSearchItem() {
            this.setPageNavigation({
                currentPage: 1,
                perPage: this.data.pageSize
            });
            this.data.department_cd = this.department_cd;
            this.searchEmployeeInfo(this.data);
        },
        changeCurrentPage(data) {
            this.data.department_cd = this.department_cd;
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.searchEmployeeInfo(this.data);
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        chooseUser(data) {
            this.$emit('onReferModelValue', data.user_cd);
            this.$emit('onReferValueName', data.user_name);
            this.$emit('close');
            // this.$emit('referDataChoose', data);
        }
    }
};
export default User;
</script>

<style lang="scss">
@use '@/assets/scss/common/popup.scss' as *;
</style>
